import Vue from 'vue';
import axios from 'axios'; 
import moment from 'moment';

const pickerDateFormat = 'YYYY-M-D';
const uiDateFormat = 'DD/MM/YYYY';

export default {
  name: 'Support',
  components: {
    TimeComp: require('../../../components/time.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appData: {
        supportService: { name: '' },
        scheduledDateTime: new Date(),
        endDateTime: new Date(),
      },
      disabledDates: date => {
        return (date < this.appData.startDateTime) || (date > this.appData.endDateTime);
      },
      logValue: 0,
      supportServiceLogType: {},
      supportServiceTypes: [],
      availableSupports: [],
      stations: [],
      supportService: { name: '' },
      showDate: { scheduledDateTime: false },
      scheduledDateTime: {},
      scheduledTime: { hours: 0, minutes: 0, descr: 'manpowers.ScheduledTime', isReadOnly: false },
    }
  },
  computed: {
    scheduledTimeHours: function () {
      return this.scheduledTime.hours;
    },
    scheduledTimeMinutes: function () {
      return this.scheduledTime.minutes;
    },
    supportServiceType: function () {
      return this.appData.supportServiceType;
    },
    allocationId: function () {
      return this.appData.allocationId;
    },
    stationId: function () {
      return this.appData.stationId;
    },
    supportServiceId: function () {
      return this.supportService.supportServiceId;
    },
  },
  watch: {
    supportService: function (value) {
      if (value.supportServiceId && this.$refs.select) {
        this.appData.supportService = value;
        this.appData.supportServiceId = value.supportServiceId;
        this.$refs.select.open = false;
      }
    },
    scheduledTimeHours: function (value) {
      this.appData.scheduledTimeHH = value;
    },
    scheduledTimeMinutes: function (value) {
      this.appData.scheduledTimeMin = value;
    },
    supportServiceType: function (value) {
      if (this.appData.supportServiceType && this.appData.supportServiceId && (this.appData.supportServiceId > 0)) {
        this.getSupportServiceLogType();
      }
      this.appData.supportServiceId = -1;
      this.getAvailableSupports();
    },
    stationId: function (value) {
      this.getAvailableSupports();
    },
    supportServiceId: function (value) {
      if (this.supportService.supportServiceId > 0) {
        this.getSupportServiceLogType();
      }
    }
  },
  created() {
    this.getStations();
    this.getSupportServiceTypes();
    this.init();
    this.$root.$on('support_updated', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.dataObj.supportService = { name: '' };
        this.appData = this.dataObj;

        this.scheduledTime.hours = this.appData.scheduledTimeHH;
        this.scheduledTime.minutes = this.appData.scheduledTimeMin;
      });
    },
    getStations() {
      axios.post('/Om/GetStations')
        .then(response => {
          if (response.data.data.status == 0) {
            this.stations = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getSupportServiceLogType() {
      var parameters = { SupportServiceId: this.appData.supportServiceId, SupportServiceType: this.appData.supportServiceType };
      axios.post('/Om/GetSupportServiceLogType', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.supportServiceLogType = response.data.item;
            this.appData.hasLogReading = this.supportServiceLogType!==null? this.supportServiceLogType.hasLogReading: false;
            this.appData.logName = this.supportServiceLogType !== null ? this.supportServiceLogType.logName: '';
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getSupportServiceTypes() {
      axios.post('/Om/GetSupportLookups')
        .then(response => {
          this.supportServiceTypes = response.data.supportServiceTypes;
          var parameters = { StationId: -1, TeamId: -1, Filter: '', SupportServiceType: 0 };
          axios.post('/Om/GetAvailableSupportServices', parameters)
            .then(response => {
              if (response.data.data.status == 0) {
                this.availableSupports = response.data.items;
                var singleSupport = this.availableSupports.filter(t => t.supportServiceId == this.appData.supportServiceId);
                if (singleSupport.length>0)
                  this.dataObj.supportService = singleSupport[0];
              }
            })
            .catch(e => { this.$router.push('/login'); return false; })
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getAvailableSupports() {
      var parameters = { StationId: this.stationId, TeamId: -1, Filter: '', SupportServiceType: this.supportServiceType };
      axios.post('/Om/GetAvailableSupportServices', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            this.availableSupports = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getFilteredSupportServices() {
      var res = (this.appData.supportServiceType != 0) ?
        this.availableSupports.filter(t => t.supportServiceType == this.appData.supportServiceType && t.stationId == this.stationId) : this.availableSupports;
      return res;
    },
  },
}

